import {createStore} from "redux";
import {ruta} from "../reducers/ruta";

const initialState = {
  language: 'es',
  idRuta: 102,
  fetchingState: false, // [0: false, 1: true]
  mes: getCurrentMonth(),
  anio: getCurrentYear(),
  dataDisp: [],
  serviceState: 'active'
};

function getCurrentMonth() {
  let d = new Date();
  return d.getMonth();
}

function getCurrentYear() {
  let d = new Date();
  return d.getFullYear();
}

// export const store = createStore(
//   ruta,
//   initialState,
//   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

export const store = createStore(
  ruta,
  initialState
);
